import ManagementCampaign from './ManagementCampaign';

export default ManagementCampaign;
